var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"messagesBlock"}},[_c('ul',_vm._l((_vm.messages),function(message){return _c('messagecontent',{attrs:{"message":message}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }